module.exports = __webpack_public_path__ + "static/55gde-2affe70f9573771ad41a045fa63042b4.gif";